export default __webpack_public_path__ + "static/media/milestone 650.5e8c6c20.svg";